import murmurhash from 'murmurhash-js';
import db from '../dexie-db/db';
import SyncBoxState from './SyncBoxState';
export function generateSyncBoxId(config) {
    return String(murmurhash.murmur3(JSON.stringify({
        filters: config.pullConfig.filters,
        collectionName: config.collectionName,
        remoteCollectionName: config.remoteCollectionName,
    }), 0));
}
export async function getSyncBoxIdFromNodeId(tableName, nodeId) {
    const node = await db.table(tableName).get(nodeId);
    return node?._syncBoxId;
}
export async function getSyncBoxStateFromNodeId(tableName, nodeId) {
    const syncBoxId = await getSyncBoxIdFromNodeId(tableName, nodeId);
    if (!syncBoxId)
        return null;
    return new SyncBoxState(syncBoxId);
}
/**
 * Derives the SyncBoxState for a sync box identified purely by its config
 * (collection + pull filters), without needing a node to already exist in Dexie.
 *
 * This is required when the "is data available offline?" check must target a
 * different sync box than the queried node's owning box - e.g. a list query
 * whose results live in a sub-tree sync box (filters: { ancestors: <rootId> })
 * rather than the box that owns the root node itself.
 */
export function getSyncBoxStateFromFilters(collectionName, remoteCollectionName, filters) {
    const syncBoxId = generateSyncBoxId({
        collectionName,
        remoteCollectionName,
        pushConfig: {},
        pullConfig: { filters },
    });
    return new SyncBoxState(syncBoxId);
}
